import {Component, DestroyRef} from '@angular/core';
import {Router} from '@angular/router';
import {FormControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../../sdk/service/alert.service';
import {AuthenticationService} from '../../../sdk/service/authentication.service';
import {PublicService} from 'web-angular-client';
import {AsyncValidators} from '../../../sdk/validator/AsyncValidators';
import {SyncValidators} from '../../../sdk/validator/SyncValidators';
import {EnvironmentService} from '../../../sdk/service/environment.service';
import {DropdownItem} from '../../../sdk/interface/data/DropdownItem';
import {ConstantsUtil} from '../../../sdk/util/constantsUtil';
import {SignupStep1BaseComponent} from './signup-step1-base.component';

@Component({
    selector: 'app-signup-step1-full',
    templateUrl: './signup-step1-full.component.html',
    styleUrls: ['./signup-step1.shared.scss'],
    standalone: false
})
export class SignupStep1FullComponent extends SignupStep1BaseComponent
{
    readonly businessTypeList: DropdownItem[] = ConstantsUtil.BUSINESS_TYPE_LIST;
    readonly clientBaseList: DropdownItem[] = [
        {value: '0 - 1 000'},
        {value: '1 000 - 5 000'},
        {value: '5 000 - 10 000'},
        {value: '10 000 - 50 000'},
        {value: '50 000 - 100 000'},
        {value: '100 000+'}
    ];
    readonly averageTransactionValueList: DropdownItem[] = [
        {value: 'R0,00 - R250,00'},
        {value: 'R250,00 - R500,00'},
        {value: 'R500,00 - R1 000,00'},
        {value: 'R1 000,00 - R2 500,00'},
        {value: 'R2 500,00+'}
    ];

    constructor(
        router: Router,
        formBuilder: UntypedFormBuilder,
        alertService: AlertService,
        authenticationService: AuthenticationService,
        publicService: PublicService,
        environmentService: EnvironmentService,
        destroyRef: DestroyRef,
    )
    {
        super(router, formBuilder, alertService, authenticationService, publicService, environmentService, destroyRef);
    }

    getBusinessDisplayNameTooltip(): string
    {
        return 'Organisation trading name, this will be displayed on invoices.';
    }

    protected buildForm(): UntypedFormGroup
    {
        return this.formBuilder.group({
            businessType: new FormControl(
                {value: this.businessType, disabled: this.shouldDisableBusinessType()},
                Validators.required),
            businessDisplayName: ['', [Validators.required, Validators.maxLength(30)]],
            businessName: [
                '',
                [Validators.required, Validators.maxLength(255)],
                AsyncValidators.validateBusinessName(this.publicService)
            ],
            name: ['', Validators.required],
            surname: ['', Validators.required],
            email: [
                '', [Validators.required, Validators.email], AsyncValidators.validateUserEmail(this.publicService)
            ],
            confirmEmail: ['', [Validators.required]],
            mobileNumber: ['', [Validators.required, SyncValidators.validateMobileNumber()]],
            password: ['', [Validators.required, SyncValidators.validatePassword]],
            confirmPassword: ['', Validators.required],
            clientBase: [null, Validators.required],
            averageTransactionValue: [null, Validators.required],
            marketingConsent: [false],
            termsAccepted: [false, Validators.requiredTrue]
        }, {validator: [SyncValidators.validatePasswordMatch(), SyncValidators.validateEmailMatch()]});
    }
}
